// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StatusItem-module__font-s-10___E58N9 {
  font-size: 10px !important;
}

.StatusItem-module__font-s-12___j8vmj {
  font-size: 12px !important;
}

.StatusItem-module__font-s-13___lq8lx {
  font-size: 13px !important;
}

.StatusItem-module__font-s-14___PxQ6h {
  font-size: 14px !important;
}

.StatusItem-module__font-s-15___XEUNT {
  font-size: 15px !important;
}

.StatusItem-module__font-s-16___pxROi {
  font-size: 16px !important;
}

.StatusItem-module__font-s-18___hFB1_ {
  font-size: 18px !important;
}

.StatusItem-module__font-s-20___BJZT7 {
  font-size: 20px !important;
}

.StatusItem-module__font-s-22___RmQGl {
  font-size: 22px !important;
}

.StatusItem-module__font-s-28___Apo7F {
  font-size: 28px !important;
}

.StatusItem-module__font-w-400___TuQgd {
  font-weight: 400 !important;
}

.StatusItem-module__font-w-500___Er9D7 {
  font-weight: 500 !important;
}

.StatusItem-module__font-w-600___ZFNS9 {
  font-weight: 600 !important;
}

.StatusItem-module__font-w-700___mUgVY {
  font-weight: 700 !important;
}

.StatusItem-module__p-5___ejraU {
  padding: 5px !important;
}

.StatusItem-module__p-12___ZTI3x {
  padding: 12px !important;
}

.StatusItem-module__p-16___yuhqh {
  padding: 16px !important;
}

.StatusItem-module__p-30___o9SIu {
  padding: 30px !important;
}

.StatusItem-module__p-b-0___G_FRa {
  padding-bottom: 0 !important;
}

.StatusItem-module__p-b-5___B74r2 {
  padding-bottom: 5px !important;
}

.StatusItem-module__p-b-10___vbRie {
  padding-bottom: 10px !important;
}

.StatusItem-module__p-b-12___f4w4t {
  padding-bottom: 12px !important;
}

.StatusItem-module__p-b-16___gq1FO {
  padding-bottom: 16px !important;
}

.StatusItem-module__p-b-18___BypiJ {
  padding-bottom: 18px !important;
}

.StatusItem-module__p-b-20___hbs6s {
  padding-bottom: 20px !important;
}

.StatusItem-module__p-b-25___P8iVZ {
  padding-bottom: 25px !important;
}

.StatusItem-module__p-b-30___JqIBZ {
  padding-bottom: 30px !important;
}

.StatusItem-module__p-b-50___D2WWb {
  padding-bottom: 50px !important;
}

.StatusItem-module__p-t-0___OzI6c {
  padding-top: 0 !important;
}

.StatusItem-module__p-t-12___dBZwF {
  padding-top: 12px !important;
}

.StatusItem-module__p-t-16___BUuI1 {
  padding-top: 16px !important;
}

.StatusItem-module__p-t-18___ostJQ {
  padding-top: 18px !important;
}

.StatusItem-module__p-t-20___h3QZQ {
  padding-top: 20px !important;
}

.StatusItem-module__p-t-30___9P1yV {
  padding-top: 30px !important;
}

.StatusItem-module__p-t-40___wJ4Jh {
  padding-top: 40px !important;
}

.StatusItem-module__p-t-50___aDWk4 {
  padding-top: 50px !important;
}

.StatusItem-module__p-l-20___lHdBb {
  padding-left: 20px !important;
}

.StatusItem-module__p-l-30___iLjTF {
  padding-left: 30px !important;
}

.StatusItem-module__p-l-40___nkSef {
  padding-left: 40px !important;
}

.StatusItem-module__p-r-16____j_8M {
  padding-right: 16px !important;
}

.StatusItem-module__p-r-20___y7i0o {
  padding-right: 20px !important;
}

.StatusItem-module__p-r-30___MpMcW {
  padding-right: 30px !important;
}

.StatusItem-module__p-r-50___forru {
  padding-right: 50px !important;
}

.StatusItem-module__p-r-60___lILOO {
  padding-right: 60px !important;
}

.StatusItem-module__m-b-1___vvd0i {
  margin-bottom: 1px !important;
}

.StatusItem-module__m-b-2___WzaQl {
  margin-bottom: 2px !important;
}

.StatusItem-module__m-b-6___BIdGa {
  margin-bottom: 6px !important;
}

.StatusItem-module__m-b-8___vzbK8 {
  margin-bottom: 8px !important;
}

.StatusItem-module__m-b-10___Qsyu3 {
  margin-bottom: 10px !important;
}

.StatusItem-module__m-b-14___w_TUH {
  margin-bottom: 14px !important;
}

.StatusItem-module__m-b-16___Z6VW3 {
  margin-bottom: 16px !important;
}

.StatusItem-module__m-b-20___sUb3W {
  margin-bottom: 20px !important;
}

.StatusItem-module__m-b-22___fRMC8 {
  margin-bottom: 22px !important;
}

.StatusItem-module__m-b-24___tpd7O {
  margin-bottom: 24px !important;
}

.StatusItem-module__m-b-30___lFUwK {
  margin-bottom: 30px !important;
}

.StatusItem-module__m-b-32___C6rf1 {
  margin-bottom: 32px !important;
}

.StatusItem-module__m-b-40___pmyOt {
  margin-bottom: 40px !important;
}

.StatusItem-module__m-t-2___z8KA5 {
  margin-top: 2px !important;
}

.StatusItem-module__m-t-3___dnswJ {
  margin-top: 3px !important;
}

.StatusItem-module__m-t-4___M6iwE {
  margin-top: 4px !important;
}

.StatusItem-module__m-t-5___S2c1q {
  margin-top: 5px !important;
}

.StatusItem-module__m-t-8___qk_SK {
  margin-top: 8px !important;
}

.StatusItem-module__m-t-10___F2IYQ {
  margin-top: 10px !important;
}

.StatusItem-module__m-t-15___jXQ9q {
  margin-top: 15px !important;
}

.StatusItem-module__m-t-16___D_mn8 {
  margin-top: 16px !important;
}

.StatusItem-module__m-t-20___cBB9A {
  margin-top: 20px !important;
}

.StatusItem-module__m-t-22___qUWHB {
  margin-top: 22px !important;
}

.StatusItem-module__m-t-30___dYYaH {
  margin-top: 30px !important;
}

.StatusItem-module__m-t-32___v5aDB {
  margin-top: 32px !important;
}

.StatusItem-module__m-l-auto___dKo33 {
  margin-left: auto !important;
}

.StatusItem-module__m-l-4___eRSUE {
  margin-left: 4px !important;
}

.StatusItem-module__m-l-5___NrG0p {
  margin-left: 5px !important;
}

.StatusItem-module__m-l-6___hFLir {
  margin-left: 6px !important;
}

.StatusItem-module__m-l-8___aYLFT {
  margin-left: 8px !important;
}

.StatusItem-module__m-l-10___VKjYR {
  margin-left: 10px !important;
}

.StatusItem-module__m-l-16___L36wo {
  margin-left: 16px !important;
}

.StatusItem-module__m-l-20___ZrduQ {
  margin-left: 20px !important;
}

.StatusItem-module__m-l-24___rGGhP {
  margin-left: 24px !important;
}

.StatusItem-module__m-l-30___jrnv2 {
  margin-left: 30px !important;
}

.StatusItem-module__m-l-35___Ft4B7 {
  margin-left: 35px !important;
}

.StatusItem-module__m-l-40_____DIk {
  margin-left: 40px !important;
}

.StatusItem-module__m-r-8___udpZ0 {
  margin-right: 8px !important;
}

.StatusItem-module__m-r-10___nHVs0 {
  margin-right: 10px !important;
}

.StatusItem-module__m-r-16___WyIBt {
  margin-right: 16px !important;
}

.StatusItem-module__m-r-20___LaknN {
  margin-right: 20px !important;
}

.StatusItem-module__m-r-24____A6j1 {
  margin-right: 24px !important;
}

.StatusItem-module__m-r-30___hREjN {
  margin-right: 30px !important;
}

.StatusItem-module__m-r-40___YGAwg {
  margin-right: 40px !important;
}

.StatusItem-module__border-r-3___NlV5M {
  border-radius: 3px !important;
}

.StatusItem-module__border-r-4___m6ZB5 {
  border-radius: 4px !important;
}

.StatusItem-module__border-r-6___sLD7Y {
  border-radius: 6px !important;
}

.StatusItem-module__border-r-10___MbnlS {
  border-radius: 10px !important;
}

.StatusItem-module__border-r-12___bmuBu {
  border-radius: 12px !important;
}

.StatusItem-module__border-r-16___xmoIS {
  border-radius: 16px !important;
}

.StatusItem-module__border-r-50___GPsTw {
  border-radius: 50% !important;
}

.StatusItem-module__primary-border___Eaj7W {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.StatusItem-module__primary-border-b___ZzboN {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.StatusItem-module__primary-border-t___e471i {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.StatusItem-module__primary-border-l___yB5_P {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.StatusItem-module__primary-border-r___xm7Wu {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.StatusItem-module__secondary-border___vvzWP {
  border: 1px solid #637768;
}

.StatusItem-module__secondary-border-b___oZNuM {
  border-bottom: 1px solid #637768;
}

.StatusItem-module__secondary-border-t___PoVt7 {
  border-top: 1px solid #637768;
}

.StatusItem-module__secondary-border-l___pyNPF {
  border-left: 1px solid #637768;
}

.StatusItem-module__secondary-border-r___RYi_N {
  border-right: 1px solid #637768;
}

.StatusItem-module__gap-0___XYKCz {
  gap: 0 !important;
}

.StatusItem-module__gap-2___WcIEu {
  gap: 2px !important;
}

.StatusItem-module__gap-4___s6n9Q {
  gap: 4px !important;
}

.StatusItem-module__gap-5___s3yJS {
  gap: 5px !important;
}

.StatusItem-module__gap-6___zZrGL {
  gap: 6px !important;
}

.StatusItem-module__gap-8___bSEEw {
  gap: 8px !important;
}

.StatusItem-module__gap-10___gzLF7 {
  gap: 10px !important;
}

.StatusItem-module__gap-12___vKJ9D {
  gap: 12px !important;
}

.StatusItem-module__gap-14___rJBf1 {
  gap: 14px !important;
}

.StatusItem-module__gap-16___BloF9 {
  gap: 16px !important;
}

.StatusItem-module__gap-18___m178X {
  gap: 18px !important;
}

.StatusItem-module__gap-20___w2ieY {
  gap: 20px !important;
}

.StatusItem-module__gap-24___QvYtH {
  gap: 24px !important;
}

.StatusItem-module__gap-26____EnGD {
  gap: 26px !important;
}

.StatusItem-module__gap-30___OgAmh {
  gap: 30px !important;
}

.StatusItem-module__gap-32___Y7qTY {
  gap: 32px !important;
}

.StatusItem-module__gap-40___NPdIq {
  gap: 40px !important;
}

.StatusItem-module__gap-50___GKWcu {
  gap: 50px !important;
}

.StatusItem-module__flex-1___YPB0F {
  flex: 1;
}

.StatusItem-module__flex-none___dYTsI {
  flex: none !important;
}

.StatusItem-module__flex-column___DInqR {
  display: flex;
  flex-direction: column !important;
}

.StatusItem-module__flex-row___Dy1oE {
  display: flex;
  flex-direction: row !important;
}

.StatusItem-module__vertically-centered___EgaoM {
  display: flex;
  align-items: center !important;
}

.StatusItem-module__horizontally-centered___uyWG1 {
  display: flex;
  justify-content: center !important;
}

.StatusItem-module__horizontally-end___EFPwr {
  display: flex;
  justify-content: end !important;
}

.StatusItem-module__vertically-start___PWqxo {
  display: flex;
  align-items: start !important;
}

.StatusItem-module__space-between___Re0EI {
  display: flex;
  justify-content: space-between !important;
}

.StatusItem-module__flex-wrap___VNHwA {
  flex-wrap: wrap !important;
}

.StatusItem-module__height-100___XNprq {
  height: 100%;
}

.StatusItem-module__width-50___glq1F {
  width: 50% !important;
}

.StatusItem-module__width-100___Wlt5g {
  width: 100%;
}

.StatusItem-module__cursor-pointer___dK5rE {
  cursor: pointer;
}

.StatusItem-module__cursor-not-allowed___D5Pbe {
  cursor: not-allowed !important;
}

.StatusItem-module__absolute-centered___PxIbk {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.StatusItem-module__absolute___mFtpP {
  position: absolute;
}

.StatusItem-module__relative___mLLcI {
  position: relative;
}

.StatusItem-module__fixed___lQXBX {
  position: fixed;
}

.StatusItem-module__visible___mJ5Cz {
  opacity: 1;
}

.StatusItem-module__invisible___QITAD {
  opacity: 0;
}

.StatusItem-module__col-90___FralW {
  width: 90% !important;
}

.StatusItem-module__col-auto___Ffg2u {
  width: auto !important;
}

.StatusItem-module__medical-tabs___PFSm8 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.StatusItem-module__medical-table-new___flCPa {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.StatusItem-module__medical-table-new___flCPa:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.StatusItem-module__medical-table-new___flCPa::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.StatusItem-module__medical-table-new___flCPa::-webkit-scrollbar-track {
  display: none;
}
.StatusItem-module__medical-table-new___flCPa.StatusItem-module__no-pagination___P9V6E {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.StatusItem-module__medical-table-new___flCPa.StatusItem-module__no-pagination___P9V6E:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.StatusItem-module__medical-table-new___flCPa.StatusItem-module__no-pagination___P9V6E::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.StatusItem-module__medical-table-new___flCPa.StatusItem-module__no-pagination___P9V6E::-webkit-scrollbar-track {
  display: none;
}

.StatusItem-module__medical-table-empty___yyc3R {
  padding: 14px 40px !important;
}

.StatusItem-module__icon-btn___Dajte {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.StatusItem-module__search-icon___FJAeL {
  width: 24px;
  height: 24px;
  align-self: center;
}

.StatusItem-module__disable-select___grxo_ {
  user-select: none;
}

.StatusItem-module__break-word___pJSKe {
  word-break: break-word;
}

.StatusItem-module__popup-clear-btn___ji7QP {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.StatusItem-module__scroll-m-b-20___mWmJK {
  scroll-margin-bottom: 20px;
}

.StatusItem-module__container___Bk9WP.StatusItem-module__notActive___dU4YT, .StatusItem-module__container___Bk9WP.StatusItem-module__disabled___TsPVw {
  opacity: 0.5;
  cursor: not-allowed;
}
.StatusItem-module__container___Bk9WP .StatusItem-module__text___J2iQC {
  color: white;
  line-height: 17px;
  letter-spacing: -0.011em;
  padding: 4px 8px;
  border-radius: 17px;
}
.StatusItem-module__container___Bk9WP .StatusItem-module__text___J2iQC.StatusItem-module__small___KhQrh {
  font-size: 13px;
  padding: 2px 6px;
}
.StatusItem-module__container___Bk9WP .StatusItem-module__downIcon___H8SRj {
  width: 18px;
  height: 18px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./../common/src/components/elements/StatusItem/StatusItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA1pBE;EAEE,YAAA;EACA,mBAAA;AA4pBJ;AAzpBE;EACE,YAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;AA2pBJ;AAzpBI;EACE,eAAA;EACA,gBAAA;AA2pBN;AAvpBE;EACE,WAAA;EACA,YAAA;AAypBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  &.notActive,\n  &.disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  .text {\n    color: get-color(white);\n    line-height: 17px;\n    letter-spacing: -0.011em;\n    padding: 4px 8px;\n    border-radius: 17px;\n\n    &.small {\n      font-size: 13px;\n      padding: 2px 6px;\n    }\n  }\n\n  .downIcon {\n    width: 18px;\n    height: 18px;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `StatusItem-module__font-s-10___E58N9`,
	"fontS12": `StatusItem-module__font-s-12___j8vmj`,
	"fontS13": `StatusItem-module__font-s-13___lq8lx`,
	"fontS14": `StatusItem-module__font-s-14___PxQ6h`,
	"fontS15": `StatusItem-module__font-s-15___XEUNT`,
	"fontS16": `StatusItem-module__font-s-16___pxROi`,
	"fontS18": `StatusItem-module__font-s-18___hFB1_`,
	"fontS20": `StatusItem-module__font-s-20___BJZT7`,
	"fontS22": `StatusItem-module__font-s-22___RmQGl`,
	"fontS28": `StatusItem-module__font-s-28___Apo7F`,
	"fontW400": `StatusItem-module__font-w-400___TuQgd`,
	"fontW500": `StatusItem-module__font-w-500___Er9D7`,
	"fontW600": `StatusItem-module__font-w-600___ZFNS9`,
	"fontW700": `StatusItem-module__font-w-700___mUgVY`,
	"p5": `StatusItem-module__p-5___ejraU`,
	"p12": `StatusItem-module__p-12___ZTI3x`,
	"p16": `StatusItem-module__p-16___yuhqh`,
	"p30": `StatusItem-module__p-30___o9SIu`,
	"pB0": `StatusItem-module__p-b-0___G_FRa`,
	"pB5": `StatusItem-module__p-b-5___B74r2`,
	"pB10": `StatusItem-module__p-b-10___vbRie`,
	"pB12": `StatusItem-module__p-b-12___f4w4t`,
	"pB16": `StatusItem-module__p-b-16___gq1FO`,
	"pB18": `StatusItem-module__p-b-18___BypiJ`,
	"pB20": `StatusItem-module__p-b-20___hbs6s`,
	"pB25": `StatusItem-module__p-b-25___P8iVZ`,
	"pB30": `StatusItem-module__p-b-30___JqIBZ`,
	"pB50": `StatusItem-module__p-b-50___D2WWb`,
	"pT0": `StatusItem-module__p-t-0___OzI6c`,
	"pT12": `StatusItem-module__p-t-12___dBZwF`,
	"pT16": `StatusItem-module__p-t-16___BUuI1`,
	"pT18": `StatusItem-module__p-t-18___ostJQ`,
	"pT20": `StatusItem-module__p-t-20___h3QZQ`,
	"pT30": `StatusItem-module__p-t-30___9P1yV`,
	"pT40": `StatusItem-module__p-t-40___wJ4Jh`,
	"pT50": `StatusItem-module__p-t-50___aDWk4`,
	"pL20": `StatusItem-module__p-l-20___lHdBb`,
	"pL30": `StatusItem-module__p-l-30___iLjTF`,
	"pL40": `StatusItem-module__p-l-40___nkSef`,
	"pR16": `StatusItem-module__p-r-16____j_8M`,
	"pR20": `StatusItem-module__p-r-20___y7i0o`,
	"pR30": `StatusItem-module__p-r-30___MpMcW`,
	"pR50": `StatusItem-module__p-r-50___forru`,
	"pR60": `StatusItem-module__p-r-60___lILOO`,
	"mB1": `StatusItem-module__m-b-1___vvd0i`,
	"mB2": `StatusItem-module__m-b-2___WzaQl`,
	"mB6": `StatusItem-module__m-b-6___BIdGa`,
	"mB8": `StatusItem-module__m-b-8___vzbK8`,
	"mB10": `StatusItem-module__m-b-10___Qsyu3`,
	"mB14": `StatusItem-module__m-b-14___w_TUH`,
	"mB16": `StatusItem-module__m-b-16___Z6VW3`,
	"mB20": `StatusItem-module__m-b-20___sUb3W`,
	"mB22": `StatusItem-module__m-b-22___fRMC8`,
	"mB24": `StatusItem-module__m-b-24___tpd7O`,
	"mB30": `StatusItem-module__m-b-30___lFUwK`,
	"mB32": `StatusItem-module__m-b-32___C6rf1`,
	"mB40": `StatusItem-module__m-b-40___pmyOt`,
	"mT2": `StatusItem-module__m-t-2___z8KA5`,
	"mT3": `StatusItem-module__m-t-3___dnswJ`,
	"mT4": `StatusItem-module__m-t-4___M6iwE`,
	"mT5": `StatusItem-module__m-t-5___S2c1q`,
	"mT8": `StatusItem-module__m-t-8___qk_SK`,
	"mT10": `StatusItem-module__m-t-10___F2IYQ`,
	"mT15": `StatusItem-module__m-t-15___jXQ9q`,
	"mT16": `StatusItem-module__m-t-16___D_mn8`,
	"mT20": `StatusItem-module__m-t-20___cBB9A`,
	"mT22": `StatusItem-module__m-t-22___qUWHB`,
	"mT30": `StatusItem-module__m-t-30___dYYaH`,
	"mT32": `StatusItem-module__m-t-32___v5aDB`,
	"mLAuto": `StatusItem-module__m-l-auto___dKo33`,
	"mL4": `StatusItem-module__m-l-4___eRSUE`,
	"mL5": `StatusItem-module__m-l-5___NrG0p`,
	"mL6": `StatusItem-module__m-l-6___hFLir`,
	"mL8": `StatusItem-module__m-l-8___aYLFT`,
	"mL10": `StatusItem-module__m-l-10___VKjYR`,
	"mL16": `StatusItem-module__m-l-16___L36wo`,
	"mL20": `StatusItem-module__m-l-20___ZrduQ`,
	"mL24": `StatusItem-module__m-l-24___rGGhP`,
	"mL30": `StatusItem-module__m-l-30___jrnv2`,
	"mL35": `StatusItem-module__m-l-35___Ft4B7`,
	"mL40": `StatusItem-module__m-l-40_____DIk`,
	"mR8": `StatusItem-module__m-r-8___udpZ0`,
	"mR10": `StatusItem-module__m-r-10___nHVs0`,
	"mR16": `StatusItem-module__m-r-16___WyIBt`,
	"mR20": `StatusItem-module__m-r-20___LaknN`,
	"mR24": `StatusItem-module__m-r-24____A6j1`,
	"mR30": `StatusItem-module__m-r-30___hREjN`,
	"mR40": `StatusItem-module__m-r-40___YGAwg`,
	"borderR3": `StatusItem-module__border-r-3___NlV5M`,
	"borderR4": `StatusItem-module__border-r-4___m6ZB5`,
	"borderR6": `StatusItem-module__border-r-6___sLD7Y`,
	"borderR10": `StatusItem-module__border-r-10___MbnlS`,
	"borderR12": `StatusItem-module__border-r-12___bmuBu`,
	"borderR16": `StatusItem-module__border-r-16___xmoIS`,
	"borderR50": `StatusItem-module__border-r-50___GPsTw`,
	"primaryBorder": `StatusItem-module__primary-border___Eaj7W`,
	"primaryBorderB": `StatusItem-module__primary-border-b___ZzboN`,
	"primaryBorderT": `StatusItem-module__primary-border-t___e471i`,
	"primaryBorderL": `StatusItem-module__primary-border-l___yB5_P`,
	"primaryBorderR": `StatusItem-module__primary-border-r___xm7Wu`,
	"secondaryBorder": `StatusItem-module__secondary-border___vvzWP`,
	"secondaryBorderB": `StatusItem-module__secondary-border-b___oZNuM`,
	"secondaryBorderT": `StatusItem-module__secondary-border-t___PoVt7`,
	"secondaryBorderL": `StatusItem-module__secondary-border-l___pyNPF`,
	"secondaryBorderR": `StatusItem-module__secondary-border-r___RYi_N`,
	"gap0": `StatusItem-module__gap-0___XYKCz`,
	"gap2": `StatusItem-module__gap-2___WcIEu`,
	"gap4": `StatusItem-module__gap-4___s6n9Q`,
	"gap5": `StatusItem-module__gap-5___s3yJS`,
	"gap6": `StatusItem-module__gap-6___zZrGL`,
	"gap8": `StatusItem-module__gap-8___bSEEw`,
	"gap10": `StatusItem-module__gap-10___gzLF7`,
	"gap12": `StatusItem-module__gap-12___vKJ9D`,
	"gap14": `StatusItem-module__gap-14___rJBf1`,
	"gap16": `StatusItem-module__gap-16___BloF9`,
	"gap18": `StatusItem-module__gap-18___m178X`,
	"gap20": `StatusItem-module__gap-20___w2ieY`,
	"gap24": `StatusItem-module__gap-24___QvYtH`,
	"gap26": `StatusItem-module__gap-26____EnGD`,
	"gap30": `StatusItem-module__gap-30___OgAmh`,
	"gap32": `StatusItem-module__gap-32___Y7qTY`,
	"gap40": `StatusItem-module__gap-40___NPdIq`,
	"gap50": `StatusItem-module__gap-50___GKWcu`,
	"flex1": `StatusItem-module__flex-1___YPB0F`,
	"flexNone": `StatusItem-module__flex-none___dYTsI`,
	"flexColumn": `StatusItem-module__flex-column___DInqR`,
	"flexRow": `StatusItem-module__flex-row___Dy1oE`,
	"verticallyCentered": `StatusItem-module__vertically-centered___EgaoM`,
	"horizontallyCentered": `StatusItem-module__horizontally-centered___uyWG1`,
	"horizontallyEnd": `StatusItem-module__horizontally-end___EFPwr`,
	"verticallyStart": `StatusItem-module__vertically-start___PWqxo`,
	"spaceBetween": `StatusItem-module__space-between___Re0EI`,
	"flexWrap": `StatusItem-module__flex-wrap___VNHwA`,
	"height100": `StatusItem-module__height-100___XNprq`,
	"width50": `StatusItem-module__width-50___glq1F`,
	"width100": `StatusItem-module__width-100___Wlt5g`,
	"cursorPointer": `StatusItem-module__cursor-pointer___dK5rE`,
	"cursorNotAllowed": `StatusItem-module__cursor-not-allowed___D5Pbe`,
	"absoluteCentered": `StatusItem-module__absolute-centered___PxIbk`,
	"absolute": `StatusItem-module__absolute___mFtpP`,
	"relative": `StatusItem-module__relative___mLLcI`,
	"fixed": `StatusItem-module__fixed___lQXBX`,
	"visible": `StatusItem-module__visible___mJ5Cz`,
	"invisible": `StatusItem-module__invisible___QITAD`,
	"col90": `StatusItem-module__col-90___FralW`,
	"colAuto": `StatusItem-module__col-auto___Ffg2u`,
	"medicalTabs": `StatusItem-module__medical-tabs___PFSm8`,
	"medicalTableNew": `StatusItem-module__medical-table-new___flCPa`,
	"noPagination": `StatusItem-module__no-pagination___P9V6E`,
	"medicalTableEmpty": `StatusItem-module__medical-table-empty___yyc3R`,
	"iconBtn": `StatusItem-module__icon-btn___Dajte`,
	"searchIcon": `StatusItem-module__search-icon___FJAeL`,
	"disableSelect": `StatusItem-module__disable-select___grxo_`,
	"breakWord": `StatusItem-module__break-word___pJSKe`,
	"popupClearBtn": `StatusItem-module__popup-clear-btn___ji7QP`,
	"scrollMB20": `StatusItem-module__scroll-m-b-20___mWmJK`,
	"container": `StatusItem-module__container___Bk9WP`,
	"notActive": `StatusItem-module__notActive___dU4YT`,
	"disabled": `StatusItem-module__disabled___TsPVw`,
	"text": `StatusItem-module__text___J2iQC`,
	"small": `StatusItem-module__small___KhQrh`,
	"downIcon": `StatusItem-module__downIcon___H8SRj`
};
module.exports = ___CSS_LOADER_EXPORT___;
